module.exports = __webpack_public_path__ + "img/340.f3c6c42.png";